export default "__VITE_ASSET__DaBT3uM___"